import React from 'react'
import { orderNumberOf } from './mediaConstraints'

// Thông tin đơn hàng đầy đủ của 1 dòng: Số đơn, Số lượng item, Loại sản phẩm, Size, Note (nếu có).
const OrderInfoPanel = ({ orderData, barcode }) => {
    const order3D = (orderData && (orderData.order3D || orderData.product)) || {}
    const { type, size, total_item } = order3D
    // Số đơn = mã bỏ hậu tố item (_1, _2...). Mỗi dòng là 1 đơn, không phải 1 item.
    const orderNumber = orderNumberOf(barcode)
    const note = orderData
        && orderData._origin_request
        && orderData._origin_request.related_data
        && orderData._origin_request.related_data.requested
        && orderData._origin_request.related_data.requested.note

    return (
        <div className="OrderInfoPanel">
            <div className="info-row">
                <label>Số đơn:</label>
                <span>{orderNumber ? `#${orderNumber}` : '—'}</span>
            </div>
            {total_item != null && total_item !== '' && (
                <div className="info-row">
                    <label>Số lượng item:</label>
                    <span>{total_item}</span>
                </div>
            )}
            <div className="info-row">
                <label>Loại sản phẩm:</label>
                <span>{type || '—'}</span>
            </div>
            <div className="info-row">
                <label>Size:</label>
                <span>{size || '—'}</span>
            </div>
            {note && (
                <div className="info-note">
                    <label>Note:</label>
                    <span>{note}</span>
                </div>
            )}
        </div>
    )
}

export default OrderInfoPanel
